(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (!canHover) {
    function clearHoverState() {
      document.querySelectorAll('.cm_product-item__image-container.cm-is-hovering').forEach(function (node) {
        node.classList.remove('cm-is-hovering');
      });
    }

    document.addEventListener('touchstart', clearHoverState, true);
    document.addEventListener('touchend', clearHoverState, true);
    return;
  }

  function bindImageHover(container) {
    if (container.dataset.cmHoverBound === 'true') return;

    var secondary = container.querySelector('.cm_product-item__image_secondary');
    if (!secondary) return;

    container.dataset.cmHoverBound = 'true';

    container.addEventListener('mouseenter', function () {
      container.classList.add('cm-is-hovering');
    });

    container.addEventListener('mouseleave', function () {
      container.classList.remove('cm-is-hovering');
    });
  }

  function bindAll(root) {
    root.querySelectorAll('.cm_product-item__image-container').forEach(bindImageHover);
  }

  bindAll(document);

  if (window.MutationObserver) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        var root = document.querySelector('.cm_SearchResult') || document.querySelector('.cm_related-products');
        if (root) bindAll(root);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
